import { HomeOwnershipInformationLabel } from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/HomeOwnershipTab/HomeOwnershipInfo/homeOwnershipInfo.enums';

export const getAddressCaptionMessage = (label: HomeOwnershipInformationLabel) => {
  return `${label} can only contain letters and numbers. Commas and other special characters are not allowed`;
};

export const validateCityField = (value: string, fieldName: string) => {
  // allow "a-z", space
  const regex = /^[a-zA-Z\s]+$/;

  if (!regex.test(value)) {
    return `${fieldName} can only contain Latin letters`;
  }
};

export const removeIncorrectSymbols = (value: string) => {
  return value
    .replace(/[^a-zA-Z0-9]/g, ' ')
    .replace(/\s+/g, ' ')
    .trimStart();
};
